const USER_MANAGEMENT_DATA_FETCHING = 'USER_MANAGEMENT_DATA_FETCHING';
const USER_MANAGEMENT_DATA_FETCHED = 'USER_MANAGEMENT_DATA_FETCHED';
const USER_MANAGEMENT_DATA_FETCHING_FAILED = 'USER_MANAGEMENT_DATA_FETCHING_FAILED';

const PATTERN_VALIDATION_ERROR = "pattern";
const GLOBAL_USER="role::global_user"
const ADMIN_USER="role::admin"
const EU_USER="role::eu_user"
const US_USER="role::us_user"
const ADMIN_ACCESS_RIGHT = "Admin"
const VIEWER_ACCESS_RIGHT = "Viewer"

const ADMIN_PRINCIPLE_TYPE =  "User"

const GROUP_USER_DATA_FETCHING = 'GROUP_USER_DATA_FETCHING';
const GROUP_USER_DATA_FETCHED = 'GROUP_USER_DATA_FETCHED';
const GROUP_USER_DATA_FETCHING_FAILED = 'GROUP_USER_DATA_FETCHING_FAILED';

const GROUP_ADD_USER_FETCHING = 'GROUP_ADD_USER_FETCHING';
const GROUP_ADD_USER_FETCHED = 'GROUP_ADD_USER_FETCHED';
const GROUP_ADD_USER_FETCHING_FAILED = 'GROUP_ADD_USER_FETCHING_FAILED';


const GROUP_REMOVE_USER_FETCHING = 'GROUP_REMOVE_USER_FETCHING';
const GROUP_REMOVE_USER_FETCHED = 'GROUP_REMOVE_USER_FETCHED';
const GROUP_REMOVE_USER_FETCHING_FAILED = 'GROUP_REMOVE_USER_FETCHING_FAILED';

const USER_ASSIGNED_GROUP_FETCHING = 'USER_ASSIGNED_GROUP_FETCHING';
const USER_ASSIGNED_GROUP_FETCHED = 'USER_ASSIGNED_GROUP_FETCHED';
const USER_ASSIGNED_GROUP_FETCHING_FAILED = 'USER_ASSIGNED_GROUP_FETCHING_FAILED';
const USER_ASSIGNED_GROUP_FETCHING_RESET='USER_ASSIGNED_GROUP_FETCHING_RESET';

const ADMIN_ASSIGNED_GROUP_FETCHING = 'ADMIN_ASSIGNED_GROUP_FETCHING';
const ADMIN_ASSIGNED_GROUP_FETCHED = 'ADMIN_ASSIGNED_GROUP_FETCHED';
const ADMIN_ASSIGNED_GROUP_FETCHING_FAILED = 'ADMIN_ASSIGNED_GROUP_FETCHING_FAILED';

const REFRESH_USER_MANAGEMENT_DATA = 'REFRESH_USER_MANAGEMENT_DATA';

export {
    USER_MANAGEMENT_DATA_FETCHING,
    USER_MANAGEMENT_DATA_FETCHED,
    USER_MANAGEMENT_DATA_FETCHING_FAILED,
    PATTERN_VALIDATION_ERROR,
    
    GROUP_USER_DATA_FETCHING,
    GROUP_USER_DATA_FETCHED,
    GROUP_USER_DATA_FETCHING_FAILED,

    GROUP_ADD_USER_FETCHING,
    GROUP_ADD_USER_FETCHED,
    GROUP_ADD_USER_FETCHING_FAILED,
    
    GROUP_REMOVE_USER_FETCHING,
    GROUP_REMOVE_USER_FETCHED,
    GROUP_REMOVE_USER_FETCHING_FAILED,

    USER_ASSIGNED_GROUP_FETCHING,
    USER_ASSIGNED_GROUP_FETCHED,
    USER_ASSIGNED_GROUP_FETCHING_FAILED,
    USER_ASSIGNED_GROUP_FETCHING_RESET,

    ADMIN_ACCESS_RIGHT,
    VIEWER_ACCESS_RIGHT,
    ADMIN_PRINCIPLE_TYPE,
    ADMIN_USER,

    ADMIN_ASSIGNED_GROUP_FETCHING,
    ADMIN_ASSIGNED_GROUP_FETCHED,
    ADMIN_ASSIGNED_GROUP_FETCHING_FAILED,
    
    REFRESH_USER_MANAGEMENT_DATA

}